import { PropsWithChildren } from 'react';
import { Switch as SwitchPrimitive } from 'radix-ui';

import { cn } from '@components/primitives/utilities';

import styles from './styles.module.css';

export interface SwitchThumbProps extends PropsWithChildren {
  className?: string;
}

/**
 * The track and the thumb that slides along it. Children ride inside the
 * thumb, which is where an icon or a spinner goes. A `<Switch>` with no
 * children renders one of these on its own.
 */
export function SwitchThumb({ className, children }: SwitchThumbProps) {
  return (
    <span className={styles.track}>
      <SwitchPrimitive.Thumb className={cn(styles.thumb, className)}>
        {children}
      </SwitchPrimitive.Thumb>
    </span>
  );
}
